__turbopack_context__.v({
  "breadcrumbs": "bread-crumbs-module-scss-module__Er4m9a__breadcrumbs",
  "item": "bread-crumbs-module-scss-module__Er4m9a__item",
  "link": "bread-crumbs-module-scss-module__Er4m9a__link",
  "linkGray": "bread-crumbs-module-scss-module__Er4m9a__linkGray",
  "list": "bread-crumbs-module-scss-module__Er4m9a__list",
  "separator": "bread-crumbs-module-scss-module__Er4m9a__separator",
});
